/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_TitleInputs */

const en_auth_error_title = /** @type {(inputs: Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const pt_br2_auth_error_title = /** @type {(inputs: Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Auth_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const auth_error_title = /** @type {((inputs?: Auth_Error_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_error_title(inputs)
	return pt_br2_auth_error_title(inputs)
});